import GenericSlider from "generic-slider";

if (!customElements.get("tech-module")) {
    class TechModule extends GenericSlider {
        constructor() {
            super();
            this.swiperThumbs = this.querySelectorAll('.tech-module__icons .tech-module__icon');
        }

        handleThumbsClick() {
            this.swiperThumbs.forEach((button, index) => {
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.slider.swiper.slideTo(index);
                });
            });
        }

        swiperSlideChange() {
            const currentIndex = this.slider.swiper.realIndex;
            this.swiperThumbs.forEach((button, index) => {
                button.setAttribute("aria-selected", index === currentIndex ? "true" : "false");
            });
        }

        connectedCallback() {
            super.connectedCallback();
            this.handleThumbsClick();
            this.slider.swiper.on("slideChange", () => {
                this.swiperSlideChange();
            });
        }
    }

    customElements.define("tech-module", TechModule);
}
